






import Vue from 'vue';
import baseMenu from './BaseMenu.vue';

export default Vue.extend({
    components: { baseMenu },
    data: () => {
        return {
            links: [
                {
                    icon: 'mdi-view-list',
                    label: 'labels.attributi',
                    href: '/attributi',
                },
                {
                    icon: 'mdi-view-list',
                    label: 'labels.avvocati',
                    href: '/avvocati',
                },
                {
                    icon: 'mdi-view-list',
                    label: 'labels.compagnie-assicurative',
                    href: '/compagnie-assicurative',
                },
                {
                    icon: 'mdi-view-list',
                    label: 'labels.enti-sanitari',
                    href: '/enti-sanitari',
                },
                {
                    icon: 'mdi-view-list',
                    label: 'labels.operatori-sanitari',
                    href: '/operatori-sanitari',
                },
                {
                    icon: 'mdi-view-list',
                    label: 'labels.pazienti',
                    href: '/pazienti',
                },
                {
                    icon: 'mdi-view-list',
                    label: 'labels.richiedenti',
                    href: '/richiedenti',
                },
            ],
        };
    },
});
